import { navSections } from "@/mocks/feed";
import { contactInfo } from "@/mocks/site";

const extraLinks = [
  { label: "线索投稿", href: "#about" },
  { label: "读者反馈", href: "#faq" },
  { label: "事件档案", href: "#tracking" },
  { label: "反转记录", href: "#reversal" },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1320px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* brand */}
          <div className="md:col-span-5">
            <a href="#headline" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                吃瓜<span className="text-primary-600">前线</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              {contactInfo.slogan}
              专注最新爆料与事件追踪，持续跟进后续进展、最新回应与反转更新，让你始终站在吃瓜第一线。
            </p>
            <a
              href={`mailto:${contactInfo.email}`}
              className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              {contactInfo.email}
            </a>
          </div>

          {/* quick nav */}
          <div className="md:col-span-3">
            <h4 className="mb-4 font-label text-xs font-bold uppercase tracking-[0.2em] text-secondary-500">
              栏目导航
            </h4>
            <nav className="grid grid-cols-2 gap-x-4 gap-y-2.5" aria-label="页脚导航">
              {navSections.map((s) => (
                <a
                  key={s.id}
                  href={`#${s.id}`}
                  className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {s.label}
                </a>
              ))}
            </nav>
          </div>

          {/* more */}
          <div className="md:col-span-2">
            <h4 className="mb-4 font-label text-xs font-bold uppercase tracking-[0.2em] text-secondary-500">
              更多
            </h4>
            <nav className="flex flex-col gap-2.5" aria-label="更多链接">
              {extraLinks.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          {/* note */}
          <div className="md:col-span-2">
            <h4 className="mb-4 font-label text-xs font-bold uppercase tracking-[0.2em] text-secondary-500">
              内容声明
            </h4>
            <p className="text-xs leading-6 text-secondary-500">
              本页所载事件与人物为资讯演示用途，不代表真实事件或现实人物，请勿对号入座。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-secondary-500">
            © {new Date().getFullYear()} 吃瓜前线 ChiGuaQianXian · 版权所有
          </p>
          <p className="flex items-center gap-2 text-xs text-secondary-500">
            <i className="ri-verified-badge-line text-primary-500" aria-hidden="true"></i>
            先核后发 · 进展必回访 · 反转即重写
          </p>
        </div>
      </div>
    </footer>
  );
}